import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CarImg from "../../assets/carinspection.png";
import CarImgA from "../../assets/carinspection_A.png";
import FinalImg from "../../assets/finalcheck.png";
import FinalImgA from "../../assets/finalcheck_A.png";
import FluidImg from "../../assets/fuildcheck.png";
import FluidImgA from "../../assets/fuildcheck_A.png";
import GeneralImg from "../../assets/generalInfo.png";
import GeneralImgA from "../../assets/generalInfo_A.png";
import LightImg from "../../assets/lightscheck.png";
import LightImgA from "../../assets/lightscheck_A.png";
import OilImg from "../../assets/oilcheck.png";
import OilImgA from "../../assets/oilcheck_A.png";
import SafetyImg from "../../assets/safetycheck.png";
import SafetyImgA from "../../assets/safetycheck_A.png";
import TireImg from "../../assets/tirecheck.png";
import TireImgA from "../../assets/tirecheck_A.png";
import Header from "../Header";
import CarInspections from "./CarInspections";
import FinalChecks from "./FinalChecks";
import FluidsCheck from "./FluidsCheck";
import GeneralInfo from "./GeneralInfo";
import LightCheck from "./LightCheck";
import OilCheck from "./OilCheck";
import SafetyChecks from "./SafetyChecks";
import TiresInspection from "./TiresInspection";
// Import new repair-specific components
import RepairStep1 from "./RepairStep1";
import RepairStep2 from "./RepairStep2";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTabIndex } from "../actions";
import PreviewMainForm from "./PreviewMainForm";
import {
  APL_LINK,
  server_post_data,
  get_needed_maintainance_data,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  mondayDayYearFormat,
} from "../../CommonJquery/CommonJquery";
import PreviewNotes from "./PreviewNotes";

function MaintananceForm({ id, id2, FromCome }) {
  const [count, setCount] = useState(0);
  const dispatch = useDispatch();
  const activeTabIndex = useSelector((state) => state?.activeTabIndex || 0);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [staffData, setStaffData] = useState([]);
  const [cardata, setCarData] = useState([]);
  const [MaintainanceData, setMaintainanceData] = useState([]);
  const [MaintainanceData_prev, setMaintainanceData_prev] = useState([]);
  const [isDataComplete, setIsDataComplete] = useState(null);
  const [BookingData, setBookingData] = useState([]);
  const [ImageLink, setImageLink] = useState("");
  const [ImageLinkIpass, setImageLinkIpass] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  useEffect(() => {
    master_data_get();
  }, []);

  useEffect(() => {
    master_data_get();
  }, [count]);

  useEffect(() => {
    dispatch(setActiveTabIndex(0));
  }, [id, id2, dispatch]);

  //console.log("ImageLinkIpass", ImageLinkIpass);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("maintainance_id", id2);
    fd.append("previous_data", 0);

    await server_post_data(get_needed_maintainance_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("Maintance Data:", Response.data.message);
          console.log(
            "Maintance Data Previous:",
            Response.data.message.maintenance_data_prev
          );
          setMaintainanceData(Response.data.message.maintenance_data);
          setMaintainanceData_prev(Response.data.message.maintenance_data_prev);
          setStaffData(Response.data.message.staff_data);
          setCarData(Response.data.message.car_data);
          setBookingData(Response.data.message.booking_data);
          setImageLink(APL_LINK + Response.data.message.image_link);
          setImageLinkIpass(APL_LINK + Response.data.message.ipass_link);
          // Set the reason from existing data
          if (Response.data.message.maintenance_data?.maintenance_reasion) {
            setSelectedReason(
              Response.data.message.maintenance_data.maintenance_reasion
            );
          }
        }
        setshowLoaderAdmin(false);
        setIsDataComplete(true);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const tabs = [
    { label: "Preview Notes", img: GeneralImg, activeImg: GeneralImgA },
    { label: "General Info", img: GeneralImg, activeImg: GeneralImgA },
    { label: "Light Check", img: LightImg, activeImg: LightImgA },
    { label: "Oil Check", img: OilImg, activeImg: OilImgA },
    { label: "Tires Inspection", img: TireImg, activeImg: TireImgA },
    { label: "Fluids Check", img: FluidImg, activeImg: FluidImgA },
    { label: "Car Inspections", img: CarImg, activeImg: CarImgA },
    { label: "Safety Checks", img: SafetyImg, activeImg: SafetyImgA },
    { label: "Final Checks", img: FinalImg, activeImg: FinalImgA },
    {
      label: "Preview Form",
      img: FinalImg,
      activeImg: FinalImgA,
      hidden: true,
    },
  ];

  const renderContent = () => {
    const activeTab = tabs[activeTabIndex];
    if (isDataComplete) {
      switch (activeTabIndex) {
        case 0:
          return (
            <>
              <PreviewNotes
                MaintainanceData_prev={MaintainanceData_prev}
                MaintainanceData={MaintainanceData}
                ImageLink={ImageLink}
                staffData={staffData}
                setCount={setCount}
                BookingData={BookingData}
                cardata={cardata}
                FromComeData={FromCome}
                onNext={handleNext}
                onBack={handleBack}
              />
            </>
          );
        case 1:
          return (
            <GeneralInfo
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              staffData={staffData}
              setCount={setCount}
              BookingData={BookingData}
              cardata={cardata}
              FromComeData={FromCome}
              onNext={handleNext}
              onBack={handleBack}
            />
          );
        case 2:
          return (
            <LightCheck
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              onNext={handleNext}
              onBack={handleBack}
              BookingData={BookingData}
              FromComeData={FromCome}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 3:
          return (
            <OilCheck
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              onNext={handleNext}
              BookingData={BookingData}
              onBack={handleBack}
              FromComeData={FromCome}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 4:
          return (
            <TiresInspection
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              onNext={handleNext}
              BookingData={BookingData}
              onBack={handleBack}
              FromComeData={FromCome}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 5:
          return (
            <FluidsCheck
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              onNext={handleNext}
              onBack={handleBack}
              BookingData={BookingData}
              FromComeData={FromCome}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 6:
          return (
            <CarInspections
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              BookingData={BookingData}
              ImageLinkIpass={ImageLinkIpass}
              onNext={handleNext}
              FromComeData={FromCome}
              onBack={handleBack}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 7:
          return (
            <SafetyChecks
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              BookingData={BookingData}
              onNext={handleNext}
              FromComeData={FromCome}
              onBack={handleBack}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 8:
          return (
            <FinalChecks
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              FromComeData={FromCome}
              BookingData={BookingData}
              onNext={handleNext}
              onBack={handleBack}
              setCount={setCount}
              cardata={cardata}
            />
          );
        case 9:
          return (
            <PreviewMainForm
              MaintainanceData_prev={MaintainanceData_prev}
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              ImageLinkIpass={ImageLinkIpass}
              onNext={handleNext}
              BookingData={BookingData}
              FromComeData={FromCome}
              onBack={handleBack}
              setCount={setCount}
              cardata={cardata}
            />
          );
        default:
          return (
            // <PreviewNotes
            //   MaintainanceData_prev={MaintainanceData_prev}
            //   MaintainanceData={MaintainanceData}
            //   ImageLink={ImageLink}
            //   ImageLinkIpass={ImageLinkIpass}
            //   onNext={handleNext}
            //   BookingData={BookingData}
            //   FromComeData={FromCome}
            //   onBack={handleBack}
            //   setCount={setCount}
            //   cardata={cardata}
            // />
            <PreviewMainForm
              MaintainanceData_prev={MaintainanceData_prev}
              MaintainanceData={MaintainanceData}
              ImageLink={ImageLink}
              ImageLinkIpass={ImageLinkIpass}
              onNext={handleNext}
              BookingData={BookingData}
              FromComeData={FromCome}
              onBack={handleBack}
              setCount={setCount}
              cardata={cardata}
            />
          );
      }
    }
  };

  const handleTabClick = (index) => {
    dispatch(setActiveTabIndex(index));
  };

  const handleNext = () => {
    const nextIndex = activeTabIndex + 1;
    if (nextIndex < tabs.length) {
      dispatch(setActiveTabIndex(nextIndex));
    }
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    const prevIndex = activeTabIndex - 1;
    if (prevIndex >= 0) {
      dispatch(setActiveTabIndex(prevIndex));
    }
    window.scrollTo(0, 0);
  };

  return (
    <div className="dashboard">
      <Header />
      <div className="container-lg"></div>
      <div
        className="dashboard_container"
        style={{ backgroundColor: "#ECECEC" }}
      >
        <div className="page_content">
          <div className="page_content_container">
            <div className="page_body">
              <div className="app-container">
                <div className="aminStickyFormHead">
                  <div className="navigation-barMain">
                    {tabs
                      .filter((tab) => !tab.hidden)
                      .map((tab, index) => (
                        <div key={index} className="main_tab_box mb-2">
                          <div
                            className={`nav-itemMain ${
                              activeTabIndex === index ? "active" : ""
                            } ${index <= count ? "" : "eventNone"}`}
                            onClick={() => handleTabClick(index)}
                          >
                            {activeTabIndex === index ? (
                              <img src={tab.activeImg} />
                            ) : (
                              <img src={tab.img} />
                            )}
                            <div className="nav-labelMain">{tab.label}</div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <hr className="hrmaniForm" />
                  <div className="header-info">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex flex-wrap">
                        <span>Date: {mondayDayYearFormat(new Date())}</span>
                        <span className="mx-2" style={{ color: "#000000" }}>
                          |
                        </span>
                        <span>Plate No.: {cardata?.car_no}</span>
                        <span className="mx-2" style={{ color: "#000000" }}>
                          |
                        </span>{" "}
                        <span>Fleet No.: {cardata?.car_tagline}</span>
                        <span className="mx-2" style={{ color: "#000000" }}>
                          |
                        </span>{" "}
                        <span>Driver Name: {BookingData?.name}</span>
                      </div>
                      {activeTabIndex === 0 && (
                        <div className="vehilce_previe_suummry">
                          <span>Vehicle Inspection Summary</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="content-container">{renderContent()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintananceForm;
